import { Routes } from '@angular/router';

import { LoginComponent } from './pages/login/login.component';
import { AdminLayoutComponent } from './pages/admin-layout/admin-layout.component';
import { RoomVisualizerComponent } from './components/room-visualizer/room-visualizer.component';
import { EstimatorpageComponent } from './pages/estimatorpage/estimatorpage.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'estimator',
    component: EstimatorpageComponent
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'visualizer',
    component: RoomVisualizerComponent
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'categories',
        pathMatch: 'full'
      },
      {
        path: 'categories',
        loadComponent: () =>
          import('./pages/category-series/category-series.component')
            .then((m) => m.CategorySeriesComponent)
      },
      {
        path: 'products',
        loadComponent: () =>
          import('./pages/products/products.component')
            .then((m) => m.ProductsComponent)
      },
      {
        path: 'products/create',
        loadComponent: () =>
          import('./pages/product-form/product-form.component')
            .then((m) => m.ProductFormComponent),
        data: { productMode: 'general' }
      },
      {
        path: 'products/edit/:id',
        loadComponent: () =>
          import('./pages/product-form/product-form.component')
            .then((m) => m.ProductFormComponent),
        data: { productMode: 'general' }
      },

      {
        path: 'wall',
        loadComponent: () =>
          import('./pages/wall/wall.component')
            .then((m) => m.WallComponent)
      },
      {
        path: 'wall/create',
        loadComponent: () =>
          import('./pages/product-form/product-form.component')
            .then((m) => m.ProductFormComponent),
        data: { type: 'wall' }
      },
      {
        path: 'wall/edit/:id',
        loadComponent: () =>
          import('./pages/product-form/product-form.component')
            .then((m) => m.ProductFormComponent),
        data: { type: 'wall' }
      },

      {
        path: 'floor',
        loadComponent: () =>
          import('./pages/floor/floor.component')
            .then((m) => m.FloorComponent)
      },
      {
        path: 'floor/create',
        loadComponent: () =>
          import('./pages/product-form/product-form.component')
            .then((m) => m.ProductFormComponent),
        data: { type: 'floor' }
      },
      {
        path: 'floor/edit/:id',
        loadComponent: () =>
          import('./pages/product-form/product-form.component')
            .then((m) => m.ProductFormComponent),
        data: { type: 'floor' }
      },

      {
        path: 'ceiling',
        loadComponent: () =>
          import('./pages/ceiling/ceiling.component')
            .then((m) => m.CeilingComponent)
      },
      {
        path: 'ceiling/create',
        loadComponent: () =>
          import('./pages/product-form/product-form.component')
            .then((m) => m.ProductFormComponent),
        data: { type: 'ceiling' }
      },
      {
        path: 'ceiling/edit/:id',
        loadComponent: () =>
          import('./pages/product-form/product-form.component')
            .then((m) => m.ProductFormComponent),
        data: { type: 'ceiling' }
      },

      {
        path: 'backsplash',
        loadComponent: () =>
          import('./pages/backsplash/backsplash.component')
            .then((m) => m.BacksplashComponent)
      },
      {
        path: 'backsplash/create',
        loadComponent: () =>
          import('./pages/product-form/product-form.component')
            .then((m) => m.ProductFormComponent),
        data: { type: 'backsplash' }
      },
      {
        path: 'backsplash/edit/:id',
        loadComponent: () =>
          import('./pages/product-form/product-form.component')
            .then((m) => m.ProductFormComponent),
        data: { type: 'backsplash' }
      },

      {
        path: 'templates',
        loadComponent: () =>
          import('./pages/templates/templates.component')
            .then((m) => m.TemplatesComponent)
      },
      {
        path: 'templates/create',
        loadComponent: () =>
          import('./pages/template-form/template-form.component')
            .then((m) => m.TemplateFormComponent)
      },
      {
        path: 'templates/edit/:id',
        loadComponent: () =>
          import('./pages/template-form/template-form.component')
            .then((m) => m.TemplateFormComponent)
      },

      {
        path: 'companies',
        loadComponent: () =>
          import('./pages/company/company.component')
            .then((m) => m.CompanyComponent)
      }
    ]
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];
